import React from "react";
import "../../assets/css/footer/Footer.css";

import logo from "../../assets/image/logo.png";
import { Link } from "react-router-dom";

import visa from "../../assets/image/visa.png";
import mvola from "../../assets/image/mvola.png";
import orange from "../../assets/image/orange.png";
import airtel from "../../assets/image/airtel.png";

import instagram from "../../assets/image/instagram.png";
import facebook from "../../assets/image/facebook.png";

export default function Footer() {
  const payments = [
    { key: "visa", src: visa, alt: "Visa", className: "payIcon payIcon--visa" },
    { key: "mvola", src: mvola, alt: "Mvola", className: "payIcon payIcon--mvola" },
    { key: "orange", src: orange, alt: "Orange Money", className: "payIcon payIcon--orange" },
    { key: "airtel", src: airtel, alt: "Airtel Money", className: "payIcon payIcon--airtel" },
  ];

  const siteMapDecouvrir = [
    { label: "Accueil", href: "/" },
    { label: "Publier une annonce", href: "/article/creation" },
    { label: "Contact", href: "/contact" },
  ];


  return (
    <footer className="footerWrap">
      <div className="container">
        <div className="footerInner">
          <div className="topGrid">
            {/* Left */}
            <div className="leftBlock">
              <img className="logo" src={logo} alt="Deal.mg" />

              <div className="payments" aria-label="Moyens de paiement">
                {payments.map((p) => (
                  <img key={p.key} className={p.className} src={p.src} alt={p.alt} />
                ))}
              </div>
            </div>

            {/* Middle */}
            <div className="siteMap">
              <h4 className="title">PLAN DU SITE</h4>

              <div className="linksGrid">
                <ul className="linkList">
                  {siteMapDecouvrir.map((l) => (
                    <li key={l.href}>
                      <Link className="link" to={l.href}>
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Right */}
            <div className="rightBlock">
              <div className="follow">
                <h4 className="title">SUIVEZ-NOUS</h4>

                <div className="socials">
                  {/* <a
                    className="socialBtn"
                    href="#"
                    rel="noreferrer"
                    aria-label="Instagram"
                  >
                    <img className="socialIcon" src={instagram} alt="Instagram" />
                  </a> */}

                  <a
                    className="socialBtn"
                    href="https://www.facebook.com/profile.php?id=61582215437372"
                    rel="noreferrer"
                    aria-label="Facebook"
                  >
                    <img className="socialIcon socialIcon--white" src={facebook} alt="Facebook" />
                  </a>
                </div>
              </div>

              <div className="call">
                <h4 className="title">APPELEZ-NOUS</h4>
                <div className="callRow">
                  <a className="phone" href="tel:+261343536345">Tel: +261 34 35 36 345</a>
                </div>
              </div>
            </div>
          </div>

          <hr className="divider" />

          <div className="bottomRow">
            <div className="copy">© {new Date().getFullYear()} Deal.mg</div>
            <div className="legal">
              <Link className="legalLink" to="/mentions-legales">
                MENTIONS LÉGALES
              </Link>

              <Link className="legalLink" to="/cgv-cgu">
                CGV / CGU
              </Link>
            </div>
          </div>
        </div>
      </div >
    </footer >
  );
}